<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('scope.pay') }}</div>
    <div slot="body">
      支付二维码
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <!-- <a-button @click="cancelDialog">{{ $t('dialog.ok') }}</a-button> -->
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'SaasTechSupportPayDialog',
  components: {
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
    }
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await this.params.onManager('performAction', {
          id: this.params.data[0].id,
          managerArgs: {
            action: 'pay',
          },
        })
        this.loading = false
        this.cancelDialog()
        this.$message.success(this.$t('common.success'))
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .desc {
    color: rgba(0, 0, 0, 0.45);
  }
</style>
